module.exports = __webpack_public_path__ + "img/logo-dark.c87a2a98.svg";